//#region---------------------AUTHENTICATION
export enum SignUpField {
    ROLE_PUBLIC_ID = 'rolePublicId',
    STATUS = 'status',
    USERNAME = 'userName',
    USER_EMAIL = 'userEmail',
    USER_CONTACT_NUMBER = 'userContactNumber',
    PASSWORD = 'password',
    ENABLE_2FA = 'requiresTwoFactor',
    PROFILE = 'profile',
    ACCOUNT_TYPE = 'accountType',
    RECAPTCHA_KEY = 'recaptchaKey',
    ADDRESS = 'address',
    REGISTRATION_CODE = 'registrationCode',
    VENDOR_REGISTRATION_CODE = 'vendorRegistrationCode',
}

export enum PasswordForgotField {
    USER_EMAIL = 'userEmail',
}
//#endregion

//#region---------------------NEWS
export enum NewsItemField {
    NAME = 'name',
    DATE = 'date',
    DESCRIPTION = 'description',
    COVER_IMAGE = 'coverImage',
    COVER_IMAGE_SRC = 'coverImageSRC',
    CREATED_BY_NAME = 'createByName',
    HAS_COVER_IMAGE = 'hasCoverImage',
    IS_COVER_CHANGE = 'isCoverChange',
    STATUS = 'status',
    PUBLIC_ID = 'publicId',
}

export enum NewsListField {
    COVER_IMAGE_URL = 'coverImageURL',
    COVER_IMAGE_SRC = 'coverImageSRC',
    CREATED_BY_NAME = 'createByName',
    DATE = 'date',
    DESCRIPTION = 'description',
    HAS_COVER_IMAGE = 'hasCoverImage',
    NAME = 'name',
    PUBLIC_ID = 'publicId',
    UPDATED_DATE = 'updatedDate',
}
//#endregion

//#region---------------------COMPANY
export enum AuthenticationField {
    USERNAME = 'username',
    UNAME = 'userName',
    PASSWORD = 'password',
    ACCESSIBILITIES = 'accessibilities',
    NAME = 'name',
    ROLE_PUBLIC_ID = 'rolePublicId',
    ROLE_NAME = 'roleName',
    TOKEN = 'token',
    PUBLIC_ID = 'publicId',
    CURRENCY_CODE = 'currencyCode',
    MUST_CHANGE_PASSWORD = 'mustChangePassword',
    ROLE_TYPE = 'roleType',
    VENDORS = 'vendors',
    COMPANY_NAME = "companyName",
    VENDOR_NAME = "vendorName",
    REQUIRES_TWO_FACTOR= "requiresTwoFactor",
}

export enum CompanyListField {
    PUBLIC_ID = 'publicId',
    EMAIL = 'email',
    CONTACT_PERSON = 'contactPerson',
    CONTACT_PHONE = 'contactPhoneNo',
    FULL_ADDRESS = 'fullAddress',
    LICENSE_KEY = 'key',
    NAME = 'name',
    STORAGE_CAPACITY = 'storageCapacity',
    STORAGE_USED = 'storageUsed',
    USER_CAPACITY = 'userCapacity',
    USER_SLOT_USED = 'userSlotUsed',
    UPDATED_DATE = 'updatedDate',
    ADDRESS = 'address',
    REGISTRATION_CODE = 'registrationCode',
    VENDOR = 'vendor',
}

export enum CompanyField {
    ADDRESS = 'address',
    CONTACT_PERSON = 'contactPerson',
    CONTACT_PHONE = 'contactPhoneNo',
    EMAIL = 'email',
    DATABASE = 'database',
    LICENSE = 'license',
    NAME = 'name',
    PUBLIC_ID = 'publicId',
    UPDATED_DATE = 'updatedDate',
    CREATED_DATE = 'createdDate',
    REGISTRATION_CODE = 'registrationCode',
    VENDOR_PUBLIC_ID = 'vendorPublicId',
    VENDOR = 'vendor',
    VENDOR_REGISTRATION_CODE = 'vendorRegistrationCode',
    IS_ON_PREMISE = 'isOnPremise',
    IS_DATABASE_EXIST = 'isDatabaseAvailable',
    LAST_SYNC_DATETIME = 'lastSync',
}

export enum CompanyAddressField {
    ADDRESS_TYPE = 'addressType',
    CITY = 'city',
    COUNTRY = 'country',
    FULL_ADDRESS = 'fullAddress',
    STATE = 'state',
    STREET_ADDRESS = 'streetAddress',
    ZIP_CODE = 'zipCode',
}

export enum CompanyLicenseField {
    COMPANY_NAME = 'companyName',
    COMPANY_PUBLIC_ID = 'companyPublicId',
    EXPIRY_DATE = 'expiryDate',
    ISSUE_DATE = 'issueDate',
    LICENSE_KEY = 'key',
    LICENSE_TYPE = 'licenseType',
    PUBLIC_ID = 'publicId',
    STATUS = 'status',
    STORAGE_CAPACITY = 'storageCapacity',
    STORAGE_USED = 'storageUsed',
    USER_CAPACITY = 'userCapacity',
    USER_SLOT_USED = 'userSlotUsed',
    VALIDITY = 'validity',
    VALIDITY_TYPE = 'validityType',
    MODULES = 'modules',
    ACTION = 'action',
    CREATED_DATE = 'createdDate',
}

export enum CompanyUserField {
    PUBLIC_ID = "publicId",
    NAME = "name",
    FIRST_NAME = 'firstName',
    LAST_NAME = 'lastName',
    EMPLOYEE_CODE = "employeeCode",
    USERNAME = 'userName',
    DATABASE_ID = 'database',
}
//#endregion
//#region---------------------LICENSE
export enum LicenseListField {
    COMPANY_NAME = 'companyName',
    COMPANY_PUBLIC_ID = 'companyPublicId',
    ISSUE_DATE = 'issueDate',
    EXPIRY_DATE = 'expiryDate',
    LICENSE_KEY = 'key',
    LICENSE_TYPE = 'licenseType',
    PUBLIC_ID = 'publicId',
    STATUS = 'status',
    STORAGE_CAPACITY = 'storageCapacity',
    STORAGE_USED = 'storageUsed',
    USER_CAPACITY = 'userCapacity',
    USER_SLOT_USED = 'userSlotUsed',
    VALIDITY = 'validity',
    VALIDITY_TYPE = 'validityType',
    INVOICE_EXISTS = 'invoiceExists',
    CREATED_DATE = 'createdDate',
}

export enum LicenseField {
    BILLING_DETAILS = 'billingDetails',
    COMPANY = 'company',
    COMPANY_NAME = 'companyName',
    COMPANY_PUBLIC_ID = 'companyPublicId',
    CREATED_DATE = 'createdDate',
    EXPIRY_DATE = 'expiryDate',
    ISSUE_DATE = 'issueDate',
    LICENSE_KEY = 'key',
    LICENSE_TYPE = 'licenseType',
    MODULES = 'modules',
    PUBLIC_ID = 'publicId',
    STATUS = 'status',
    STORAGE_CAPACITY = 'storageCapacity',
    STORAGE_USED = 'storageUsed',
    UPDATED_DATE = 'updatedDate',
    USER_CAPACITY = 'userCapacity',
    USER_SLOT_USED = 'userSlotUsed',
    VALIDITY = 'validity',
    VALIDITY_TYPE = 'validityType',
    INVOICE_EXISTS = 'invoiceExists',
}

export enum BuyLicensePackageField {
    PUBLIC_ID = 'publicId',
    LICENSE_TYPE = 'licenseType',
    LICENSE_PACKAGE = 'licensePackage',
    ADD_ON = 'addOn',
    VALIDITY_IN_YRS = 'validityInYrs',
    EXPIRY_DATE = 'expiryDate',
    ISSUE_DATE = 'issueDate',
    COMPANY_NAME = 'companyName',
    COMPANY_PUBLIC_ID = 'companyPublicId',
    SUB_TOTAL = 'subTotal',
    DISCOUNT_AMOUNT = 'manualDiscountAmount',
    TAX_PERCENT = 'taxPercent',
    TAX_AMOUNT = 'taxAmount',
    GRAND_TOTAL = 'grandTotal',
}

export enum BuyLicenseField {
    INVOICE = 'invoice',
    LICENSE_DETAILS = 'license',
    TRANSACTION_KEY = 'transactionKey',
}

export enum LicenseDetailsBuyField {
    LICENSE_TYPE = 'licenseType',
    STORAGE_CAPACITY = 'storageCapacity',
    USER_CAPACITY = 'userCapacity',
    VALIDITY = 'validity',
    VALIDITY_TYPE = 'validityType',
    ISSUE_DATE = 'issueDate',
    EXPIRY_DATE = 'expiryDate',
    COMPANY_PUBLIC_ID = 'companyPublicId',
    STATUS = 'status',
    MODULES = 'modules',
    BILLING_DETAILS = 'billingDetails',
}

export enum GenerateLicenseField {
    PUBLIC_ID = 'publicId',
    LICENSE_TYPE = 'licenseType',
    STORAGE_CAPACITY = 'storageCapacity',
    STORAGE_USED = 'storageUsed',
    USER_CAPACITY = 'userCapacity',
    USER_SLOT_USED = 'userSlotUsed',
    VALIDITY = 'validity',
    VALIDITY_TYPE = 'validityType',
    EXPIRY_DATE = 'expiryDate',
    ISSUE_DATE = 'issueDate',
    COMPANY_NAME = 'companyName',
    COMPANY_PUBLIC_ID = 'companyPublicId',
    STATUS = 'status',

    MODULES = 'modules',

    BILLING_DETAILS = 'billingDetails',
    SUB_TOTAL = 'subTotal',
    TAX_RATE = 'taxRate',
    TAX_AMOUNT = 'taxAmount',
    TOTAL_AMOUNT = 'totalAmount',
    IS_WITH_ANNUAL_DISCOUNT = 'isWithAnnualDiscount',
    DISCOUNT_APPLIED = 'discountApplied',
    NOTES = 'notes',
    DISCOUNT_AMOUNT = 'manualDiscountAmount',
    GENERATED_LICENSE_KEY = 'key',
}

export enum CheckoutField {
    PUBLIC_ID = 'publicId',
    COMPANY_NAME = 'companyName',
    COMPANY_PUBLIC_ID = 'companyPublicId',
    CONTACT_PERSON = 'contactPerson',
    CONTACT_PHONE = 'contactPhoneNo',
    EMAIL = 'email',
    ADDRESS = 'address',
    PAYMENT_TYPE = 'paymentType',
    BANK = 'bank',
    CARD_ACCOUNT_NAME = 'cardAccountName',
    CARD_NUMBER = 'cardNumber',
    CARD_EXPIRATION = 'cardExpiration',
    CVV = 'cvv',
    E_WALLET = 'eWallet',
    SUB_TOTAL = 'subTotal',
    DISCOUNT_AMOUNT = 'manualDiscountAmount',
    TAX_PERCENT = 'taxPercent',
    TAX_AMOUNT = 'taxAmount',
    GRAND_TOTAL = 'grandTotal',

    LICENSE_KEY = 'key',
    INVOICE_NO = 'invoiceNo',
    STATUS = 'status',
    UPDATED_DATE = 'updatedDate',
    CREATED_DATE = 'createdDate',
}
//#endregion
//#region---------------------ADMIN
export enum AdminUserListField {
    PUBLIC_ID = 'publicId',
    NAME = 'name',
    ROLE_NAME = 'roleName',
    ROLE_PUBLIC_ID = 'rolePublicId',
    STATUS = 'status',
    UPDATED_DATE = 'updatedDate',
    CREATED_DATE = 'createdDate',
    USERNAME = 'userName',
}

export enum AdminUserField {
    ADDRESS = 'address',
    PASSWORD = 'password',
    CONFIRM_PASSWORD = 'confirmPassword',
    PROFILE = 'profile',
    PUBLIC_ID = 'publicId',
    ROLE = 'role',
    ROLE_PUBLIC_ID = 'rolePublicId',
    STATUS = 'status',
    USERNAME = 'userName',
    ENABLE_2FA = 'requiresTwoFactor',
    UPDATED_DATE = 'updatedDate',
    CREATED_DATE = 'createdDate',
    USER_EMAIL = 'userEmail',
    USER_CONTACT_NUMBER = 'userContactNumber',

    NEW_PASSWORD = 'newPassword',
}

export enum AdminUserAddressField {
    ADDRESS_TYPE = 'addressType',
    CITY = 'city',
    COUNTRY = 'country',
    FULL_ADDRESS = 'fullAddress',
    STATE = 'state',
    STREET_ADDRESS = 'streetAddress',
    ZIP_CODE = 'zipCode',
}

export enum AdminUserProfileField {
    NAME = 'name',
    FIRST_NAME = 'firstName',
    LAST_NAME = 'lastName',
    EMAIL = 'email',
    CONTACT_NUMBER = 'contactNumber',
    COMPANY_PUBLIC_ID = 'companyPublicId',
    REGISTERED_COMPANY = 'registeredCompany',
    TAX_NO = 'taxNo',
    CURRENCY_CODE = 'currencyCode',
    VENDORS = 'vendors',
    VENDOR_IDS = 'vendorPublicIds',
}

export enum TwoWayFactorDataField {
    OTP_AUTH_URL = 'otpAuthUrl',
    SECRET_KEY = 'secretKey',
}
//#endregion
//#region---------------------MAINTENANCE
export enum ModuleSettingField {
    PUBLIC_ID= 'publicId',
    NAME = 'name',
    DESCRIPTION = 'description',
    STATUS = 'status',
    UPDATED_DATE = 'updatedDate',
}

// export enum RolesListField {
//     PUBLIC_ID = 'publicId',
//     NAME = 'name',
//     DESCRIPTION = 'description',
//     STATUS = 'status',
//     CREATED_DATE = 'createdDate',
//     UPDATED_DATE = 'updatedDate',
// }

export enum RolesField {
    PUBLIC_ID = 'publicId',
    NAME = 'name',
    TYPE = 'type',
    DESCRIPTION = 'description',
    STATUS = 'status',
    CREATED_DATE = 'createdDate',
    UPDATED_DATE = 'updatedDate',
}

export enum RoleAccesibilityField {
    ACCESSIBILITY_ID = 'accessibilityId',
    IS_PERMITTED = 'isPermitted',
}


export enum PriceSettingsField {
    MODULES = 'modules',
    USER_TIERS = 'userTiers',
    STORAGES = 'storages',
    ANNUAL_BILLING_DISCOUNT = 'annualBillingDiscount',
    CURRENCY_CODE = 'currencyCode',

    MODULE_PUBLIC_ID = 'publicId',
    MODULE_NAME = 'name',
    MODULE_BASE_PRICE = 'basePrice',
    MODULE_BASE_PRICE_CURRENCY_CODE = 'basePriceCurrencyCode',
    MODULE_DESCRIPTION = 'description',

    MIN_USERS = 'minUsers',
    MAX_USERS = 'maxUsers',
    USERDISCOUNT = 'discount',

    STORAGE = 'storage',
    STORAGE_PRICE = 'price',
    STORAGE_DESCRIPTION = 'description',
}

export enum VendorField {
    PUBLIC_ID= 'publicId',
    CODE = 'code',
    NAME = 'name',
    STATUS = 'status',
    COMPANIES = 'companies',
    COMPANY_PUBLIC_IDS = 'companyPublicIds',
    CREATED_DATE = 'createdDate',
    UPDATED_DATE = 'updatedDate',
}

export enum RegistrationCodeField {
    PUBLIC_ID= 'publicId',
    CODE = 'code',
    USER_TYPE = 'userType',

    // STATUS = 'status',
    CREATED_DATE = 'createdDate',
    UPDATED_DATE = 'updatedDate',
}
//#endregion

//#region---------------------BILLING
export enum ListBillingField {
    COMPANY_NAME = 'companyName',
    CREATED_DATE = 'createdDate',
    GENERATED_LICENSE_KEY = 'generatedLicenseKey',
    INVOICE_DATE = 'invoiceDate',
    PUBLIC_ID = 'publicId',
    STATUS = 'status',
    TOTAL_AFTER_ADJUSTMENT = 'totalAfterAdjustment',
    TRANS_NO = 'transNo',
    UPDATED_DATE = 'updatedDate',
    CURRENCY_CODE = 'currencyCode',
}

export enum InvoiceField {
    LINE_TOTAL = 'lineTotal',
    SUB_TOTAL = 'subtotal',
    TAX_RATE = 'taxRate',
    TAX_AMOUNT = 'taxAmount',
    TOTAL_BEFORE_ADJUSTMENT = 'totalBeforeAdjustment',
    ROUND_ADJUSTMENT = 'roundingAdjustment',
    TOTAL_AFTER_ADJUSTMENT = 'totalAfterAdjustment',
    IS_WITH_ANNUAL_DISCOUNT = 'isWithAnnualDiscount',
    ANNUAL_DISCOUNT_AMOUNT = 'annualDiscountAmount',
    ANNUAL_DISCOUNT_RATE = 'annualDiscountRate',
    BILLING_DETAILS = 'billingDetails',
    PUBLIC_ID = 'publicId',

    USER_CAPACITY_DISCOUNT = 'userCapacityDiscountRate',
    USER_CAPACITY_DISCOUNT_AMOUNT = 'userCapacityDiscountAmount',
    DISCOUNT_AMOUNT = 'manualDiscountAmount',
    CURRENCY_CODE = 'currencyCode',
}

export enum DetailsInvoiceField {
    ANNUAL_DISCOUNT_AMOUNT = 'annualDiscountAmount',
    ANNUAL_DISCOUNT_RATE = 'annualDiscountRate',
    BILLING_DETAILS = 'billingDetails',
    IS_WITH_ANNUAL_DISCOUNT = 'isWithAnnualDiscount',
    LICENSE_DETAILS = 'license',
    LINE_TOTAL = 'lineTotal',
    PAYMENT = 'payment',
    PUBLIC_ID = 'publicId',
    ROUND_ADJUSTMENT = 'roundingAdjustment',
    SUB_TOTAL = 'subtotal',
    TAX_AMOUNT = 'taxAmount',
    TAX_RATE = 'taxRate',
    TOTAL_AFTER_ADJUSTMENT = 'totalAfterAdjustment',
    TOTAL_BEFORE_ADJUSTMENT = 'totalBeforeAdjustment',
    USER_CAPACITY_DISCOUNT_AMOUNT = 'userCapacityDiscountAmount',
    USER_CAPACITY_DISCOUNT = 'userCapacityDiscountRate',
    
    TRANS_NO = 'transNo',
    STATUS = 'status',
    CREATED_DATE = 'createdDate',
    INVOICE_DATE = 'invoiceDate',
    UPDATED_DATE = 'updatedDate',
    GENERATED_LICENSE_KEY = 'generatedLicenseKey',
    GENERATED_LICENSE_PUBLIC_ID = 'licensePublicId',
    REMARKS = 'remarks',
    PENDING_ID = 'pendingId',
    COMPANY_PUBLIC_ID = 'companyPublicId',
    DISCOUNT_AMOUNT = 'manualDiscountAmount',
    CURRENCY_CODE = 'currencyCode',
}

export enum BillingLicenseDetailsField {
    LICENSE_TYPE = 'licenseType',
    STORAGE_CAPACITY = 'storageCapacity',
    USER_CAPACITY = 'userCapacity',
    VALIDITY = 'validity',
    VALIDITY_TYPE = 'validityType',
    ISSUE_DATE = 'issueDate',
    EXPIRY_DATE = 'expiryDate',
    STATUS = 'status',
    MODULES = 'modules',
}

export enum BillingPaymentField {
    AMOUNT_PAID = 'amountPaid',
    CURRENCY = 'currency',
    PAYMENT_DATE = 'paymentDate',
    PROVIDER = 'provider',
    STATUS = 'status',
    TRANSACTION_ID = 'transactionId',

    CARD_BRAND = 'cardBrand',
    LAST_4_CARD_DIGIT = 'last4CardDigit',
    PAYMENT_METHOD_ID = 'paymentMethodId',
    PAYMENT_TYPE = 'paymentType',
    REMARKS = 'remarks',
}

export enum BillingDetailsField {
    NAME = 'name',
    CONTACT_PERSON = 'contactPerson',
    CONTACT_PHONE = 'contactPhoneNo',
    EMAIL = 'email',
    ADDRESS = 'address',
    COMPANY_PUBLIC_ID = 'companyPublicId',
}

export enum BillingAddressField {
    ADDRESS_TYPE = 'addressType',
    CITY = 'city',
    COUNTRY = 'country',
    FULL_ADDRESS = 'fullAddress',
    STATE = 'state',
    STREET_ADDRESS = 'streetAddress',
    ZIP_CODE = 'zipCode',
}

export enum MakePaymentField {
    CLIENT_SECRET_KEY = 'clientSecretKey',
    INVOICE_PUBLIC_ID = 'invoicePublicId',
}

export enum StripePaymentIntentField {
    STATUS = 'status',
    INVOICE_PUBLIC_ID = 'invoicePublicId',
}

export enum CheckoutDataField {
    BILLING_DETAILS = 'billingDetails',
    VALIDITY = 'validity',
    VALIDITY_TYPE = 'validityType',
    MODULES = 'modules',
    USER_CAPACITY = 'userCapacity',
    STORAGE_CAPACITY = 'storageCapacity',
    LINE_TOTAL = 'lineTotal',
    SUB_TOTAL = 'subTotal',
    TAX_RATE = 'taxRate',
    TAX_AMOUNT = 'taxAmount',
    TOTAL_BEFORE_ADJUSTMENT = 'totalBeforeAdjustment',
    ROUND_ADJUSTMENT = 'roundingAdjustment',
    TOTAL_AFTER_ADJUSTMENT = 'totalAfterAdjustment',
    DISCOUNT_AMOUNT = 'manualDiscountAmount',
    CURRENCY_CODE = 'currencyCode',
}


//#endregion

export enum ImageFileField {
    IMAGE_FILE = 'profImage',
    VIEW_IMAGE = 'viewImage',
}


